export type IsStringValidIntegerOptions = {
	allowInfinity?: boolean;
	min?: number;
	max?: number;
};

/**
 * Check if a string is a valid integer
 * @param value Value to check
 * @param options Options
 * @return `true` if the value is a valid integer, `false` otherwise
 *
 * @example
 * ```ts
 * const isValid = isStringValidInteger('123'); // true
 * const isValid = isStringValidInteger('123.45'); // false
 * const isValid = isStringValidInteger('abc'); // false
 * ```
 */
export const isStringValidInteger = (
	v: string | number,
	{allowInfinity, min, max}: IsStringValidIntegerOptions = {},
) => {
	const asNumber =
		typeof v === 'number' && v === Infinity ? Infinity : parseInt(v.toString());
	return (
		!isNaN(asNumber) &&
		asNumber.toString() === v.toString() &&
		(allowInfinity || asNumber !== Infinity) &&
		(min === undefined || asNumber >= min) &&
		(max === undefined || asNumber <= max)
	);
};
